import {
  CLEAR_ORDERS,
  FETCH_REFUND_ORDERS,
  FETCH_ALL_ORDERS_FAILED,
  FETCH_ALL_ORDERS_SUCCEDED,
  FETCH_ALL_ORDERS_REQUESTED,
  SET_ALL_ORDERS_FILTERS,
  FETCH_REFUND_ORDERS_REQUESTED,
  FETCH_REFUND_ORDERS_SUCCEDED,
  FETCH_REFUND_ORDERS_FAILED,
  SET_REFUND_ORDERS_FILTERS,
  REFUND_ORDER_SUCCEEDED,
  REFUND_ORDER_REQUESTED,
  REFUND_ORDER_FAILED,
  SET_ORDERS_API_PARAMS_CONFIG,
} from './actionTypes'
import api from 'utils/api'

export const fetchRefundOrdersRequested = () => ({
  type: FETCH_REFUND_ORDERS_REQUESTED,
})
export const fetchRefundOrdersSucceeded = (data) => ({
  type: FETCH_REFUND_ORDERS_SUCCEDED,
  payload: data,
})
export const fetchRefundOrdersFailed = (err) => ({
  type: FETCH_REFUND_ORDERS_FAILED,
  payload: err,
})

export const fetchRefundOrders =
  (venueUuid, confirmationNumber, config) => (dispatch) => {
    dispatch(fetchRefundOrdersRequested())
    return api
      .fetchRefundOrders(venueUuid, confirmationNumber, config)
      .then(({ data }) => dispatch(fetchRefundOrdersSucceeded(data)))
      .catch((err) => dispatch(fetchRefundOrdersFailed(err)))
  }

export const fetchRefundOrdersAction = (data) => ({
  type: FETCH_REFUND_ORDERS,
  payload: data,
})

export const refundOrderSucceeded = () => ({
  type: REFUND_ORDER_SUCCEEDED,
})
export const refundOrderRequested = () => ({
  type: REFUND_ORDER_REQUESTED,
})
export const refundOrderFailed = (err) => ({
  type: REFUND_ORDER_FAILED,
  payload: err,
})

export const refundOrder =
  (orderId, refundOrderItems, refundReason, userEmail, userUuid, config) =>
  (dispatch) => {
    dispatch(refundOrderRequested())
    return api
      .refundOrderItems(
        orderId,
        refundOrderItems,
        refundReason,
        userEmail,
        userUuid,
        config
      )
      .then(() => dispatch(refundOrderSucceeded()))
      .catch((err) => dispatch(refundOrderFailed(err)))
  }

export const clearOrdersAction = () => ({
  type: CLEAR_ORDERS,
})

export const fetchAllOrdersRequested = () => ({
  type: FETCH_ALL_ORDERS_REQUESTED,
})

export const fetchAllOrdersFailed = () => ({
  type: FETCH_ALL_ORDERS_FAILED,
})

export const fetchAllOrdersSucceded = (payload) => ({
  type: FETCH_ALL_ORDERS_SUCCEDED,
  payload,
})

export const setAllOrdersFilters = (payload) => ({
  type: SET_ALL_ORDERS_FILTERS,
  payload,
})

export const setOrdersApiParamsConfig = (payload) => ({
  type: SET_ORDERS_API_PARAMS_CONFIG,
  payload,
})

export const setRefundOrdersFilter = (payload) => ({
  type: SET_REFUND_ORDERS_FILTERS,
  payload,
})

export const fetchAllOrders = (params) => (dispatch) => {
  dispatch(fetchAllOrdersRequested())

  return api
    .fetchAllOrders(params)
    .then((response) => dispatch(fetchAllOrdersSucceded(response)))
    .catch(() => dispatch(fetchAllOrdersFailed()))
}
